<template>
  <div class="card-box">
    <h4 v-if="hasHeader" class="header-title m-b-20">
      <slot name="header">{{ titulo }}</slot>
    </h4>

    <slot />

    <div class="footer" v-if="$slots.footer">
      <slot name="footer" />
    </div>
  </div>
</template>

<script>
export default {
  name: "HcCardBox",
  props: {
    titulo: {
      type: String,
      required: false
    }
  },
  computed: {
    hasHeader
  }
};

function hasHeader() {
  return this.titulo != null || this.$slots.header != null;
}
</script>
